import ComingSoon from '../../components/CommingSoon/CommingSoon';
import ProgressCard from '../../components/Piano Turistico/ProgressCard/ProgressCard'
import ProgressList from '../../components/Piano Turistico/ProgressCard/ProgressList'
import Azienda from '../../assets/images/Azienda Agricola.png'
import Bar from '../../assets/images/bar.jpg'
import Food from '../../assets/images/food.jpg'
import Rest from '../../assets/images/rest.jpg'
import Service from '../../assets/images/pharmacy.jpg'
import Bed from '../../assets/images/bed_and_breakfast.png'
import Commerci from '../../assets/images/Commerci Alimenti.png'
import Servizi from '../../assets/images/Servizi Essenziali.png'
import Animals from '../../assets/images/Produzioni Agricole Animali.jpg'
import Catania from '../../assets/images/Catania.jpg'
import Bnb from '../../assets/images/bnb.jpg'
import Agrit from '../../assets/images/Agriturismo.jpg'
import Messina from '../../assets/images/Messina.jpg'
import Agro from '../../assets/images/agri.jpg'
import Cass from '../../assets/images/Cass.jpg'
import Other from '../../assets/images/other2.jpg'

import styles from './PianoTuristico.module.css'
import Footer from '../../components/common/Footer/Footer';
const Data = () => {



    return (
      <div className={styles.container}>
    <ProgressCard  title={'Arrivi'} values={'Arrivi (visite)'}>
      <ProgressList fontSize={'12px'} img={Catania} place={'Prov. Catania (media mensile 2022)'} value={438788} color={'rgba(110, 160, 43, 0.5)'}
  total_value={822753}/> 
     <ProgressList fontSize={'12px'}
  img={Messina}
  place={'Prov. Messina (media mensile 2022)'}
  value={383965} // Passed as a number
  color={'rgba(110, 160, 43, 0.5)'}
  total_value={822753} // Passed as a number
/>
       
        {/* <ProgressList img={Agro} place={"Valle d'Agrò (2022)"} value={153324} color={'rgba(110, 160, 43, 0.5)'}
  total_value={2000000}/>  */}
       <ProgressList fontSize={'12px'} img={Cass} place={'Area CIRCE (media mensile 2023)'} value={26354} color={'rgba(110, 160, 43, 0.5)'}
  total_value={822753}/> 
     </ProgressCard>
     <ProgressCard title={'Attività'} values={'Strutture'}>
      
       <ProgressList img={Bar} place={'Bar'} value={6} color={'rgba(110, 160, 43, 0.5)'}
  total_value={51}/> 
      <ProgressList img={Rest} place={'Ristoranti'} value={7} color={'rgba(5, 93, 120, 0.5)'}
  total_value={51}/> 
  <ProgressList img={Food} place={'Alimentari'} value={7} color={'rgba(137, 43, 5, 0.5)'}
  total_value={51}/> 
  <ProgressList img={Service} place={'Servizi Essenziali'} value={7} color={'rgba(137, 5, 160, 0.5)'}
  total_value={51}/> 
         <ProgressList img={Agro} place={'Agricoltura'} value={6} color={'rgba(238, 242, 15, 0.5)'}
  total_value={51}/> 
        <ProgressList img={Other} place={'Altri'} value={21} color={'rgba(23, 161, 250, 0.5)'}
  total_value={51}/> 
      </ProgressCard>
      <ProgressCard title={'Ospitalità'} values={'Strutture'}>
      
      <ProgressList img={Bnb} place={'B&B'} value={2} color={'rgba(110, 160, 43, 0.5)'}
  total_value={4}/> 
        <ProgressList img={Agrit} place={'Agriturismo'} value={2} color={'rgba(110, 160, 43, 0.5)'}
  total_value={4}/> 
         
       
      </ProgressCard>
      <Footer></Footer>
      </div>
  );
}

export default Data; 
